import { CmsComponentsBase } from '@/cmsComponents/base';
import Container from '@uikit/components/Container/Container';
import HeatPumpSavingsCalculator from '@uikit/components/HeatPumpSavingsCalculator/HeatPumpSavingsCalculator';
import HeatPumpStageBox from '@uikit/components/HeatPumpStageBox/HeatPumpStageBox';
import HeatPumpTextBlockWithBadge from '@uikit/components/HeatPumpTextBlockWithBadge/HeatPumpTextBlockWithBadge';
import Section from '@uikit/components/Section/Section';
import TwoColumnContainer from '@uikit/components/TwoColumnContainer/TwoColumnContainer';
import HeroArea from '@uikit/composites/HeroArea/HeroArea';

const cmsComponents = {
  ...CmsComponentsBase,
  'heat-pump-container': Container,
  'heat-pump-savings-calculator': HeatPumpSavingsCalculator,
  'heat-pump-section': Section,
  'heat-pump-stage-box': HeatPumpStageBox,
  'heat-pump-stage': HeroArea,
  'heat-pump-text-block-with-badge': HeatPumpTextBlockWithBadge,
  'heat-pump-two-sided-box-alternative': TwoColumnContainer,
};

export default cmsComponents;
